import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";

const LINKS = [
  { to: "/about", label: "Philosophy", testId: "nav-link-philosophy" },
  { to: "/science", label: "The Science", testId: "nav-link-science" },
  { to: "/recipes", label: "Recipes", testId: "nav-link-recipes" },
  { to: "/coming-soon", label: "Coming Soon", testId: "nav-link-coming-soon" },
  { to: "/community", label: "Community", testId: "nav-link-community" },
  { to: "/contact", label: "Contact", testId: "nav-link-contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-paper/85 backdrop-blur-md border-b border-[#E7E2D7]">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 md:h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-brand-logo" className="flex items-center gap-2 group">
          <img loading="eager" decoding="async" fetchpriority="high"
            src="/logo.png"
            alt="Pranivaa Kitchens logo"
            className="h-10 w-10 md:h-11 md:w-11 rounded-full object-cover shadow-sm transition-transform duration-300 group-hover:rotate-6"
          />
          <span className="font-serif text-xl md:text-2xl font-semibold tracking-tight">
            Pranivaa <span className="italic text-clay">Kitchens</span>
          </span>
        </Link>
        <div className="hidden lg:flex items-center gap-7">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={l.testId}
              className={({ isActive }) =>
                `editorial-link text-sm font-medium tracking-wide ${isActive ? "text-beet" : "text-ink-soft hover:text-ink"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/coming-soon"
            data-testid="nav-cta-waitlist-button"
            className="ml-2 rounded-full bg-beet text-white text-sm font-semibold px-5 py-2.5 transition-all duration-300 hover:bg-beet-deep hover:-translate-y-0.5 hover:shadow-lg"
          >
            Join the Waitlist
          </Link>
        </div>
        <button
          data-testid="nav-mobile-menu-button"
          className="lg:hidden p-2 text-ink"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </nav>
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
            className="lg:hidden overflow-hidden bg-paper border-b border-[#E7E2D7]"
          >
            <div className="px-6 py-6 flex flex-col gap-4">
              {LINKS.map((l) => (
                <NavLink
                  key={l.to}
                  to={l.to}
                  data-testid={`mobile-${l.testId}`}
                  onClick={() => setOpen(false)}
                  className="font-serif text-2xl text-ink"
                >
                  {l.label}
                </NavLink>
              ))}
              <Link
                to="/coming-soon"
                data-testid="mobile-nav-cta-waitlist-button"
                onClick={() => setOpen(false)}
                className="mt-2 rounded-full bg-beet text-white text-center font-semibold px-5 py-3"
              >
                Join the Waitlist
              </Link>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};
